import React from 'react';
import 'twin.macro';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import { useParams } from 'react-router-dom';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@teetsh/app/src/components/Resizable';
import { Sidebar } from '@teetsh/app/src/containers/RegistreAppel/Preview/Registre/Sidebar';
import { Body } from '@teetsh/app/src/containers/RegistreAppel/Preview/Registre/Body';
import { Form } from 'react-final-form';
import { RegistreAppelPDFSettings } from '@teetsh/app/src/containers/RegistreAppel/Print/Registre/types';
import AutoSubmitForm from '@teetsh/app/src/components/AutoSave';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import getDateFromCJUrl from '@teetsh/app/src/utils/time/getDateFromCJUrl';
import startOfMonth from '@teetsh/app/src/utils/time/startOfMonth';
import endOfMonth from '@teetsh/app/src/utils/time/endOfMonth';

export function RegistreAppelPreview() {
  const user = useUser();
  const updateUser = useUpdateUser();
  const { data: userAccount } = useUserAccount();

  const params = useParams<{
    schoolyearId: string;
    schoolId: string;
    year: string;
    month: string;
    day: string;
  }>();

  const date = getDateFromCJUrl(
    params.year as string,
    params.month as string,
    params.day as string,
  );
  const from = startOfMonth(date);
  const to = endOfMonth(date);

  return (
    <Form<RegistreAppelPDFSettings>
      initialValues={user.fonts.registreAppel}
      onSubmit={async values => {
        await updateUser({
          ...user,
          fonts: {
            ...user.fonts,
            registreAppel: values,
          },
        });
        return {};
      }}
    >
      {({ handleSubmit }) => (
        <form tw="min-h-0 h-full" onSubmit={handleSubmit}>
          <AutoSubmitForm />
          <div tw="w-full h-full flex flex-col overflow-hidden">
            <ResizablePanelGroup
              direction="horizontal"
              autoSaveId="registre-appel-preview-sidebar"
            >
              <Sidebar
                from={from}
                to={to}
                lng={user.locale}
                tz={user.location}
                limitedBgSet={userAccount?.isOnOldPricing || false}
              />
              <ResizableHandle />
              <ResizablePanel order={1}>
                <div tw="h-full overflow-auto">
                  <Body
                    schoolyearId={params.schoolyearId as string}
                    schoolId={params.schoolId as string}
                    from={from}
                    to={to}
                    lng={user.locale}
                    tz={user.location}
                  />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>
        </form>
      )}
    </Form>
  );
}
